import { useAppSelector } from "../app/hooks";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import MemberAttendance from "../features/attendance/components/member-attendance";
import BusinessAttendance from "../features/attendance/components/business-attendance";
import { UserType } from "../shared/enums";

const Attendance = () => {
    const loggedInUser = useAppSelector(selectLoggedInUser);

    return (
        <div>
            <>
                {loggedInUser && loggedInUser.type === UserType.BUSINESS_USER &&
                    <BusinessAttendance />

                }
                {loggedInUser && loggedInUser.type === UserType.MEMBER &&
                    <MemberAttendance />
                }


            </>
        </div>
    )
}

export default Attendance;